__turbopack_context__.v({
  "amount": "StandingRow-module__qtHmjW__amount",
  "bidder": "StandingRow-module__qtHmjW__bidder",
  "figure": "StandingRow-module__qtHmjW__figure",
  "figureLabel": "StandingRow-module__qtHmjW__figureLabel",
  "muted": "StandingRow-module__qtHmjW__muted",
  "rank": "StandingRow-module__qtHmjW__rank",
  "row": "StandingRow-module__qtHmjW__row",
});
